$(function() {
    'use strict';

    /**
     * Set equall height for the categories in Ship listing
     */
    $('.shop_categories__head').matchHeight();
});